import InternalStaticAnchor from 'models/application/anchor/types/internalStatic/InternalStatic';

export default class InternalStaticAnchorPortal extends InternalStaticAnchor {
	_pattern = '/portal';
}
